import { GetConfigResult } from '../../api/config';

// Startup
export type ConfigAction = { type: 'SET_CONFIGURATION'; result: GetConfigResult };

export function setConfiguration(result: GetConfigResult): ConfigAction {
  return { type: 'SET_CONFIGURATION', result };
}
